import { DisplayPosition } from '@/common/manager/position/display-position';
import { componentMap as formComponentMap, formilyReact, } from '@cainiaofe/cn-ui';
import { calculateTextExprValue, executeFunction, getArrayTableCurrentRowByField2, makeButtons, } from '@/common/util/util';
import { ButtonPosition } from '@/common/manager/position/button-position';
import { __arrayTableCurrentRow__ } from '@/common/util/expr-const';
const { useField } = formilyReact;
const CnFormGrid = 'CnFormGrid';
export const config = {
    position: [
        DisplayPosition.formDialog,
        DisplayPosition.form,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'CnCardSubCard',
    formComponent: (props) => {
        const { subTitle, subDesc } = props || {};
        const extraProps = {
            title: subTitle,
            desc: subDesc,
            subTitle: undefined,
            subDesc: undefined,
        };
        if (props.shape === 'CnCardSubAreaCard') {
            return (<formComponentMap.CnCardSubAreaCard {...props} {...extraProps} shape={undefined}/>);
        }
        return (<formComponentMap.CnCard {...props} {...extraProps} shape="simple" noPadding/>);
    },
    isFormContainer: true,
    allowParentList: ['CnCard', 'CnFormStepItem', 'CnFormTabItem'],
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig = {}, formProps = {}, state, _context, urlParams, formValue, formInstance, parentPosition, } = config || {};
        const { formStyle = {} } = formProps;
        const { cols } = formStyle || {};
        if (formItem) {
            const { label, name, options = {} } = formItemConfig;
            const { buttons = [] } = options;
            const componentProps = formItem['x-component-props'] || {};
            if (componentProps) {
                if (componentProps.subTitle) {
                    componentProps.subTitle = calculateTextExprValue(componentProps.subTitle, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (componentProps.titleTips) {
                    componentProps.titleTips = calculateTextExprValue(componentProps.titleTips, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (label && !componentProps.subTitle) {
                    componentProps.subTitle = label;
                }
                if (Array.isArray(buttons) && buttons.length > 0) {
                    let action;
                    const makeButtonConfig = {
                        buttons: buttons.map((item) => {
                            let realChildren = item?.children;
                            if (typeof item?.children === 'function') {
                                realChildren = executeFunction(item.children, formValue, state);
                            }
                            return {
                                ...item,
                                style: { marginLeft: '8px' },
                                size: 'small',
                                position: ButtonPosition.subCardAction,
                                children: realChildren,
                            };
                        }),
                        _context,
                        state,
                        urlParamsDataSource: urlParams,
                        recordDataSource: formValue,
                        formInstance,
                        parentPosition,
                    };
                    if (parentPosition === DisplayPosition.cnArraySubAreaCard) {
                        action = () => {
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            const field = useField?.();
                            if (field) {
                                const currentRow = getArrayTableCurrentRowByField2(field);
                                makeButtonConfig?.buttons?.forEach?.((item) => {
                                    item.getExtraParam = () => {
                                        return {
                                            [__arrayTableCurrentRow__]: currentRow,
                                        };
                                    };
                                });
                                makeButtonConfig.arrayTableCurrentRow = currentRow;
                            }
                            return makeButtons(makeButtonConfig);
                        };
                    }
                    else {
                        action = makeButtons(makeButtonConfig);
                    }
                    if (action) {
                        componentProps.action = action;
                        delete componentProps.buttons;
                    }
                }
            }
            // if(formItemReadOnly === undefined) {
            //   formItem.readOnly = readOnly;
            // }else if(isBoolean(formItemReadOnly)) {
            //   formItem.readOnly = formItemReadOnly;
            // }
            delete formItem['x-decorator'];
            formItem.title = '';
            formItem.type = 'void';
            const { cols: subCardCols } = componentProps;
            const formGridProps = {};
            if (subCardCols) {
                formGridProps.cols = subCardCols;
            }
            else {
                formGridProps.cols = cols;
            }
            formItem.properties = {
                [`${name}_${CnFormGrid}`]: {
                    type: 'void',
                    'x-component': CnFormGrid,
                    'x-component-props': formGridProps,
                    properties: {},
                },
            };
        }
    },
};
